import $ from 'jquery';
import barba from '@barba/core';

import { replaceBodyClasses, wait } from '../global/helpers';
import { $Elements, BrowserEvents, Classes, Elements, TransitionDurations, TransitionnableLinks } from '../global/constants';

import { homeEnter, homeLeave } from '../views/home';
import { regionEnter, regionLeave } from '../views/region';
import { propertyEnter, propertyLeave } from '../views/property';

// ---------- Barba Initialisation ----------

const options = {
	sync: true,
	once: async(data) => $Elements.window.on('load', () => enter(data)),
	enter: async(data) => $Elements.document.one(BrowserEvents.page.transition, () => enter(data)),
	leave: async(data) => await leave(data),
	after: async(data) => {

		replaceBodyClasses(data.next);
		$Elements.document.trigger(BrowserEvents.page.transition);

		return;
	}
};

barba.init({
	debug: false,
	preventRunning: true,
	prevent: ({ el }) => !$(el).is(TransitionnableLinks),
	transitions: [{
		name: 'self',
		...options,
	}, {
		name: 'default',
		...options,
	}]
});

// ---------- Transitions ----------

async function enter(data) {

	switch(data.next.namespace) {

		case 'home':
			homeEnter();
			break;
		case 'region':
			regionEnter();
			break;
		case 'property':
			propertyEnter();
			break;
	}

	$Elements.document.trigger(BrowserEvents.page.enter);
	Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
	Elements.LoadingBar.classList.remove(Classes.loading);

	return;
}

async function leave(data) {

	switch(data.current.namespace) {

		case 'home':
			homeLeave();
			break;
		case 'region':
			regionLeave();
			break;
		case 'property':
			propertyLeave();
			break;
	}

	Elements.LoadingBar.classList.add(Classes.loading);
	Elements.MainWrapper.classList.add(Classes.loading);
	document.body.classList.add(Classes.leaving);
	data.current.container.classList.add(Classes.leaving);
	await wait(TransitionDurations.page);

	return;
}
